var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReleases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "28px",
    viewBox: "0 0 25 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Releases") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E98FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 25,
    height: 28,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3050311,12.9108087 C18.5212532,13.1198309 18.5270898,13.4645594 18.3180677,13.6807815 C18.1090455,13.8970035 17.7643169,13.9028402 17.5480949,13.693818 L13.5443235,9.82378694 L13.5443235,19.4595645 C13.5443235,19.7601861 13.3006216,20.003888 13,20.003888 C12.6993784,20.003888 12.4556765,19.7601861 12.4556765,19.4595645 L12.4556765,9.82367807 L8.45141524,13.693818 C8.23519318,13.90275 7.89053774,13.8968402 7.68160576,13.6806182 C7.47267378,13.4643961 7.47858355,13.1197407 7.6948056,12.9108087 L12.6216407,8.14906687 C12.6415497,8.13414257 12.6625261,8.12069803 12.6844012,8.10884137 C12.7034541,8.0941151 12.7234558,8.08065934 12.7442768,8.06856143 C12.7595723,8.06034215 12.7719829,8.04591757 12.7878227,8.03916796 L12.796042,8.03742613 C12.8288688,8.02703247 12.8626318,8.01986786 12.8968507,8.01603421 C12.9291639,8.00667272 12.9622722,8.00031346 12.9957543,7.99692846 L13.004028,7.99692846 C13.0374394,8.00016979 13.0704769,8.00651124 13.1027138,8.01587092 C13.1369132,8.01968621 13.1706581,8.02683263 13.2034681,8.0372084 L13.2122862,8.03916796 C13.2243157,8.0442846 13.2336781,8.05549767 13.245381,8.06148523 C13.270608,8.07573035 13.2946694,8.09194727 13.3173406,8.10998445 C13.3385177,8.12152714 13.3588534,8.13455071 13.378196,8.14895801 L18.3050311,12.9108087 Z",
    id: "Path-Copy",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleases);
export default __webpack_public_path__ + "static/media/releases.29eea7debd7ec84132001c26d985fe70.svg";
export { ForwardRef as ReactComponent };